import { render, staticRenderFns } from "./product_in_orig.vue?vue&type=template&id=13710789&scoped=true"
import script from "./product_in_orig.vue?vue&type=script&lang=js"
export * from "./product_in_orig.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13710789",
  null
  
)

export default component.exports